import React from 'react'
import AppMenuLink from './AppMenuLink'
import cx from 'classnames'
import './style.css'

const AppMenuSection = ({ title, links, className }) => (
  <div className={cx('app-menu-section', className)}>
    <span className="app-menu-section-title">
      {title}
    </span>
    <ul className="app-menu-section-links">
      {links.map((link, index) => (
        <AppMenuLink
          key={index}
          to={link.to}
          label={link.label}
        />
      ))}
    </ul>
  </div>
)

export default AppMenuSection
